import { render, staticRenderFns } from "./toMyGroupProblem.vue?vue&type=template&id=597bd9b0&scoped=true&"
import script from "./toMyGroupProblem.vue?vue&type=script&lang=js&"
export * from "./toMyGroupProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597bd9b0",
  null
  
)

export default component.exports